import { validateStyleMin } from "@maplibre/maplibre-gl-style-spec";
import type { AppValidationError } from "@/types/editor";

/**
 * Validates a style object and returns structured errors.
 */
export function validateStyleSpec(
  style: unknown,
): AppValidationError[] {
  if (!style || typeof style !== "object") {
    return [
      {
        message: "Style must be a valid JSON object",
        severity: "error",
        path: "",
      },
    ];
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const errors = validateStyleMin(style as any);

  return errors.map((err: { message: string; identifier?: string }) => {
    const path = err.identifier ?? "";
    const layerMatch = path.match(/layers\[(\d+)\]/);
    const sourceMatch = path.match(/sources\.([^.]+)/);

    return {
      message: err.message,
      severity: "error" as const,
      path,
      layerId: layerMatch
        ? getLayerIdAtIndex(style, Number(layerMatch[1]))
        : undefined,
      sourceId: sourceMatch ? sourceMatch[1] : undefined,
    };
  });
}

function getLayerIdAtIndex(style: unknown, index: number): string | undefined {
  const s = style as { layers?: Array<{ id?: string }> };
  return s.layers?.[index]?.id;
}
